// Admin API - barrel re-export combining all admin sub-modules

import { adminAnalyticsApi } from "./analytics";
import { adminBlogsApi } from "./blogs";
import { adminCalculatorConfigApi } from "./calculator-config";
import { adminCommunicationsApi } from "./communications";
import { adminConsultationsApi } from "./consultations";
import { adminFeedbackApi } from "./feedback";
import { adminHomePageApi } from "./home-page";
import { adminImportsApi } from "./imports";
import { adminLandingLeadsApi } from "./landing-leads";
import { adminProjectsApi } from "./projects";
import { adminProsApi } from "./pros";
import { adminRoomCategoriesApi } from "./room-categories";
import { adminRrmApi } from "./rrm";
import { adminSearchApi } from "./search";
import { adminSocialStudioMusicApi } from "./social-studio-music";
import { adminSocialStudioTemplatesApi } from "./social-studio-templates";
import { adminTaxonomyApi } from "./taxonomy";
import { adminUsersApi } from "./users";

export type { CommunicationLogEntry } from "./communications";
export type {
	ConsultationBooking,
	ConsultationBookingStatus,
} from "./consultations";
export type { FeedbackEntry } from "./feedback";
export type {
	LandingLead,
	LeadEntryType,
	LeadFilters,
	LeadStatus,
	LeadTouch,
} from "./landing-leads";
export type { HomePageCuration, HomePageProjectSummary } from "./home-page";
export type {
	MaterializeResult,
	MaterializeSelection,
	ProImportDetail,
	ProImportDetailResponse,
	ProImportEvent,
	ProImportEventsResponse,
	ProImportListItem,
	ProImportStatus,
	ScrapedPhoto,
	ScrapedProfile,
	ScrapedProject,
	TaxonomyMatch,
	TaxonomySuggestions,
	YamlParsed,
} from "./imports";
export type {
	RoomCategoryMedia,
	RoomCategoryWithStats,
} from "./room-categories";
export type { SearchIndexStatus, SearchRebuildStats } from "./search";
export type { AdminSocialStudioTemplate } from "./social-studio-templates";
export type { AdminUser, UserTenantRole } from "./users";
export { adminImportsApi };

export const adminApi = {
	...adminRrmApi,
	...adminUsersApi,
	...adminProsApi,
	...adminProjectsApi,
	...adminTaxonomyApi,
	...adminBlogsApi,
	...adminAnalyticsApi,
	...adminCommunicationsApi,
	...adminFeedbackApi,
	...adminConsultationsApi,
	...adminLandingLeadsApi,
	...adminSearchApi,
	...adminSocialStudioMusicApi,
	...adminSocialStudioTemplatesApi,
	...adminRoomCategoriesApi,
	...adminHomePageApi,
	...adminCalculatorConfigApi,
};

export type {
	RrmConsentBasis,
	RrmEvent,
	RrmFunnel,
	RrmGateCondition,
	RrmImportResult,
	RrmInboxConversation,
	RrmLocale,
	RrmMessage,
	RrmProspect,
	RrmProspectDetail,
	RrmProspectFilters,
	RrmRampState,
	RrmSignup,
	RrmSource,
	RrmStage,
	RrmSubmissionSummary,
	RrmTask,
	RrmTaskState,
	RrmTaskType,
	RrmTier,
} from "./rrm";
export { adminRrmApi };
